require("./aggregatorConsentsSuccess.scss");

// @vendors
import React from "react";
import PropTypes from "prop-types";

// @constants
import { CONTEXT_KEY } from 'constants/aggregator/aggregatorConsents.constants';

// @components
import WizardSuccess from "components/commons/wizardSuccess/wizardSuccess";

// @utilities
const { formatText, FormattedText } = require("core/i18n").i18n;

const ACCEPTED = 'ACCEPTED';

const AggregatorConsentsSuccess = ({
    ownCommercialPurpousesConsent,
    thirdPartiesCommercialPurpousesConsent,
    reset,
    history
}) => {
    const onMainButtonClick = () => {
        reset();
        history.push("/myprofile/edit");
    };
    return (
        <div className="insert-entity-credentials col-xs-offset-1 col-xs-10">
            <WizardSuccess
                successMessage={formatText(`${CONTEXT_KEY}-sucessTitle`)}
                mainButton={{
                    label: formatText(`${CONTEXT_KEY}-sucessBackLabel`)
                }}
                onMainButtonClick={onMainButtonClick}
            >
                <p className="title-sucess-bold">
                    <FormattedText value={`${CONTEXT_KEY}-sucessFirstParagraphTitle`}/>
                </p>
                {ownCommercialPurpousesConsent === ACCEPTED? formatText(`${CONTEXT_KEY}-yes`) : formatText(`${CONTEXT_KEY}-no`)}
                <p className="title-sucess-bold">
                    <FormattedText value={`${CONTEXT_KEY}-sucessSecondParagraphTitle`}/>
                </p>
                {thirdPartiesCommercialPurpousesConsent === ACCEPTED ? formatText(`${CONTEXT_KEY}-yes`) : formatText(`${CONTEXT_KEY}-no`)}
            </WizardSuccess>
        </div>
    );
};

AggregatorConsentsSuccess.propTypes = {
    ownCommercialPurpousesConsent: PropTypes.bool,
    thirdPartiesCommercialPurpousesConsent: PropTypes.bool,
    reset: PropTypes.func,
    history: PropTypes.object.isRequired
};

AggregatorConsentsSuccess.defaultProps = {
    ownCommercialPurpousesConsent: false,
    thirdPartiesCommercialPurpousesConsent: false,
    reset: () => null
};

export default AggregatorConsentsSuccess;
